import { json, useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useState } from "react";
import withLoader from "./../../components/layouts/WithLoader";
import { Alert } from "@material-ui/lab";
import { Snackbar, TextField } from "@material-ui/core";
import WarehouseService from "../../services/WarehouseService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import DataTableProductsColis from "../../ui/DataTableProductsColis";
import AddColis from "../../ui/AddColis";
import ConfigLivraisonService from "../../services/PosService/ConfigLivraisonService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faGear } from "@fortawesome/free-solid-svg-icons";

const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const AddColisLivraison = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [nbproducts, setNbproducts] = useState(0);

  const [showPageColis, setShowPageColis] = useState(false);
  const [typeResponseChanged, setTypeResponseChanged] = useState(false);

  //config livraison stat
  const [colisConfigLogin, setColisConfigLogin] = useState(null);
  const [colisConfigPassword, setColisConfigPassword] = useState(null);

  const [colisInformations, setColisInformations] = useState({});

  const [designationProduct, setDesignationProduct] = useState(null);

  const animatedComponents = makeAnimated();
  const [userRole, setUserRole] = useState("");
  //select
  const [selectedGouvernerat, setSelectedGouvernerat] = useState(null);
  const [selectedVille, setSelectedVille] = useState(null);
  const [selectedValueAutorisation, setSelectedValueAutorisation] =
    useState("Oui");
  const [selectedValueFragile, setSelectedValueFragile] = useState("Oui");
  const [selectedValueEchange, setSelectedValueEchange] = useState("Oui");
  const [selectedValueModalite, setSelectedValueModalite] = useState("2");

  const [allSorties, setAllSorties] = useState([]);
  const [selectedOptionSortie, setSelectedOptionSortie] = useState(null);
  const [btnSelectedSortie, setBtnSelectedSortie] = useState(false);
  const [showProducts, setShowProducts] = useState(false);

  const [allWarehouses, setAllWarehouses] = useState([]);
  const [selectedOptionWarehouse, setSelectedOptionWarehouse] = useState(null);
  const [btnSelectedWarehouse, setBtnSelectedWarehouse] = useState(false);
  const [products, setProducts] = useState([]);
  //alert
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState("");
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState("");

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const onChangeSelectSortie = (item) => {
    setSelectedOptionSortie(item);
    if (item && item.value && item.value.length > 0) {
      setDesignationProduct(item.value);
    }
  };
  const onChangeSelectWarehouse = (item) => {
    setSelectedOptionWarehouse(item);
    setSelectedOptionSortie("");
    setProducts([]);
  };
  const onChangetBtnSelectedWarehouse = () => {
    onGetBonneSortieByWarehouse();
  };
  const onChangeBtnSelectedSortie = () => {
    onGetProductsByBonneSortieByWarehouse();
  };
  const onGetProductsBySortie = () => {
    setShowProducts(true);
  };

  useEffect(() => {
    startLoading();
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response?.data?.success) {
          const warehouseDetails = response?.data?.success?.map((item) => ({
            label: item.name,
            value: item.id,
          }));
          setAllWarehouses(warehouseDetails);
        } else if (response?.data?.console.error) {
          setOpenErrorAlert(true);
          setErrorAlertText(response?.data?.error);
        }
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText(e);
        console.log("error : ", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  useEffect(() => {
    //get config information
    startLoading();
    ConfigLivraisonService.getDeliveryInformation(getCurrentUserId())
      .then((response) => {
        if (response.data.success) {
          if (
            response.data.success.login != null &&
            response.data.success.password != null
          ) {
            setShowPageColis(true);
          }
          setColisConfigLogin(response.data.success.login);
          setColisConfigPassword(response.data.success.password);
        } else if (response.data.error) {
          setOpenSuccessAlert(true);
          setSuccessAlertText(response.data.error);
        }
      })
      .catch((e) => {
        console.log("error", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);
  // useEffect(() => {
  //   if (selectedOptionWarehouse) {
  //     onGetBonneSortieByWarehouse();
  //   }
  // }, [selectedOptionWarehouse]);

  // useEffect(() => {
  //   if (btnSelectedWarehouse && btnSelectedSortie) {
  //     onGetProductsByBonneSortieByWarehouse();
  //   }
  // }, [btnSelectedWarehouse, btnSelectedSortie]);

  // useEffect(() => {
  //   if (products[0] && products[0].length > 0) {
  //     generateDesignationProducts();
  //   }
  // }, [products]);
  const onGetBonneSortieByWarehouse = () => {
    startLoading();
    WarehouseService.getProductTransactionHistoryByWarehouseColis(
      selectedOptionWarehouse?.value,
      getCurrentUserId(),
      1
    )
      .then((response) => {
        if (response?.data?.success) {
          setBtnSelectedWarehouse(true);
          const sortieDetails = response.data.success.map((item) => ({
            label: item,
            value: item,
          }));

          setAllSorties(sortieDetails);
        } else if (response?.data?.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("error : " + response?.data?.error);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("error : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };

  const onGetProductsByBonneSortieByWarehouse = () => {
    startLoading();
    setProducts([]);
    WarehouseService.getTransactionHistoryByTransactionId(
      selectedOptionWarehouse?.value,
      getCurrentUserId(),
      1,
      selectedOptionSortie?.value
    )
      .then((response) => {
        if (response?.data?.success) {
          setBtnSelectedSortie(true);

          if (response?.data?.success?.productSalesHistories !== null) {
            const productsDetailss =
              response?.data?.success?.productSalesHistories.map(
                (item) => item?.productSale
              ) || [];
            setTypeResponseChanged(true);
            setProducts(productsDetailss);
          } else if (response?.data?.success?.productToSalesHistories != null) {
            const productsDetails =
              // response?.data?.success?.productToSalesHistories.map(
              //   (item) =>item?.productToSale?.productSellingPrice|| []
              // ) || [];
              response?.data?.success?.productToSalesHistories.map(
                (item) => item?.productToSale || []
              ) || [];

            setProducts(productsDetails);
          }
        } else if (response?.data?.error) {
          setOpenErrorAlert(true);
          setErrorAlertText("error : " + response?.data?.error);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("error : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const filterTableProduct = () => {
    if (
      btnSelectedWarehouse &&
      btnSelectedSortie &&
      selectedOptionWarehouse &&
      selectedOptionSortie
    ) {
      if (products && products?.length > 0) {
        return (
          <DataTableProductsColis
            listProduits={products}
            bonneSortieName={selectedOptionSortie?.label}
            typeResponseChanged={typeResponseChanged}
            setNbproducts={setNbproducts}
          />
        );
      }
    }
  };
  // const generateDesignationProducts = () => {
  //   if (products[0] && products[0].length > 0) {
  //     setDesignationProduct(
  //       products[0]
  //         .map(
  //           (item) =>
  //             `${item?.product?.barcode}-${item?.product?.name}*${item?.quantity}`
  //         )
  //         .join(", ")
  //     );
  //   }
  // };

  const AddColisFormulaire = () => {
    return (
      <AddColis
        setColisInformations={setColisInformations}
        colisInformations={colisInformations}
        selectedVille={selectedVille}
        setSelectedVille={setSelectedVille}
        selectedGouvernerat={selectedGouvernerat}
        setSelectedGouvernerat={setSelectedGouvernerat}
        selectedValueAutorisation={selectedValueAutorisation}
        setSelectedValueAutorisation={setSelectedValueAutorisation}
        selectedValueFragile={selectedValueFragile}
        setSelectedValueFragile={setSelectedValueFragile}
        selectedValueEchange={selectedValueEchange}
        setSelectedValueEchange={setSelectedValueEchange}
        selectedValueModalite={selectedValueModalite}
        setSelectedValueModalite={setSelectedValueModalite}
        designationProduct={designationProduct}
        nbproducts={nbproducts}
      />
    );
  };

  function isEmpty(value) {
    return value == null || value === "" || value === undefined;
  }
  function isInvalidNombrePiece(number) {
    return number <= 0;
  }
  function isInvalidPhoneNumber(phone) {
    const phoneRegex = /^[0-9]{8}$/; // Mise à jour pour 8 chiffres
    return phone == null || !phoneRegex.test(phone);
  }
  const onSendColis = () => {
    const model = {
      login: colisConfigLogin,
      password: colisConfigPassword,
      reference: colisInformations?.reference || designationProduct, //Reference au choix pour le colis
      designation: colisInformations?.designation || designationProduct, //Désignation de produit expédié
      montant_reception: colisInformations?.montant_reception, //Prix de colis
      modalite: selectedValueModalite, // La valeur peut être 0,2 ou 3 (voir le web service Liste des modalité)
      contenuEchange: selectedValueEchange === "Oui" ? "Oui" : "", //si le colis n'est pas un colis echange il faut qu'elle soit vide
      code: selectedGouvernerat?.value, // le code postal de la gouvernorat (voir le web service liste des gouvernorat)
      ville: colisInformations?.ville, // Chaine de caractères contient le nom de ville
      tel: colisInformations?.tel, //Téléphone du destinataire
      adresse: colisInformations?.adresse, //Adresse de livraison
      nom: colisInformations?.nom, // Nom du destinataire
      nombre_piece: colisInformations?.nombre_piece || nbproducts,
      // pickup_id: "1", // Numero d'adresse d'enlèvement (A partir de canet d'adresse inseré) non obligatoire
      open_parcel: selectedValueAutorisation === "Oui" ? "1" : "0", // 0 si l'ouverture de colis interdit sinon 1 si le colis autorisé pour l'ouverture
      fragile: selectedValueFragile === "Oui" ? "1" : "0", // 0 si le colis non fragile sinon 1 si le colis est fragile
      contenuEchange: colisInformations?.contenuEchange || "",
    };
    if (
      isEmpty(model.montant_reception) &&
      isEmpty(model.code) &&
      isEmpty(model.ville) &&
      isEmpty(model.adresse) &&
      isEmpty(model.nom) &&
      isEmpty(model.nombre_piece)
    ) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez remplir les champs");
      return;
    } else if (isEmpty(model.nom)) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez saisir votre nom && prenom");
      return;
    } else if (isEmpty(model.tel)) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez saisir le numéro de téléphone");
      return;
    } else if (isInvalidPhoneNumber(model.tel)) {
      setOpenErrorAlert(true);
      setErrorAlertText("Le format du numéro de téléphone est invalide");
      return;
    } else if (isEmpty(model.code)) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez sélectionner le gouvernorat");
      return;
    } else if (isEmpty(model.ville)) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez saisir la ville");
      return;
    } else if (isEmpty(model.adresse)) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez saisir l'adresse");
      return;
    } else if (isEmpty(model.montant_reception)) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez indiquer le montant de réception");
      return;
    } else if (isInvalidNombrePiece(model.nombre_piece)) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez indiquer montant de réception valide");
      return;
    } else if (
      isEmpty(model.nombre_piece) ||
      isInvalidNombrePiece(model.nombre_piece)
    ) {
      setOpenErrorAlert(true);
      setErrorAlertText("Veuillez saisir un nombre de pièces supérieur à zéro");
      return;
    }
    // const apiUrl = "https://my.massar.tn/API/add";
    // const corsProxyUrl = "https://corsproxy.io/?";
    // const fullUrl = corsProxyUrl + apiUrl;
    startLoading();
    fetch("https://my.massar.tn/API/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(model),
      // mode: "no-cors",
    })
      .then((response) => {
        if (response.status === 200) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Colis envoyé avec succès!");
          window.location.reload();
        }
        // return response;
      })
      // .then((data) => {
      //   console.log("data : ", data);
      // })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText(e.message);
        console.log("error: ", e.message);
      })
      .finally(() => {
        stopLoading();
      });
  };

  const navigateToPageConfig = () => {
    navigate(`/configuration-colis-livraison`);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div className="card-header">
              <h5 className="card-title">Ajouter Colis</h5>
            </div>
            {!showPageColis ? (
              <div class="card-body">
                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group text-center">
                      <FontAwesomeIcon
                        icon={faGear}
                        style={{
                          width: "50px",
                          height: "50px",
                        }}
                      />
                      <div className="mb-3"></div>
                      <h4>Ajouter une configuration de colis.</h4>
                      <div className="mb-3"></div>
                      <h4>Ensuite, vous pourrez ajouter un colis</h4>
                      <div className="mb-5"></div>
                      <button
                        onClick={navigateToPageConfig}
                        type="button"
                        className="btn btn-dark"
                        style={{ width: "150px" }}
                      >
                        Cliquer
                        <FontAwesomeIcon
                          icon={faArrowRight}
                          style={{ marginLeft: "8px" }}
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>
                          Choisir warehouse{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <div className="input-group">
                          <div
                            className="input-group-prepend"
                            style={{ width: "95%" }}
                          >
                            <Select
                              styles={styles}
                              closeMenuOnSelect={true}
                              components={animatedComponents}
                              defaultValue={selectedOptionWarehouse}
                              onChange={onChangeSelectWarehouse}
                              options={allWarehouses}
                            />
                          </div>
                          <div className=" input-group-append">
                            <button
                              onClick={onChangetBtnSelectedWarehouse}
                              type="button"
                              class="btn btn-dark"
                            >
                              <i class="fas  fa-solid fa-arrow-down"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {btnSelectedWarehouse && selectedOptionWarehouse && (
                    <div class="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <label>
                            Choisir le bon de sortie{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <div className="input-group">
                            <div
                              className="input-group-prepend"
                              style={{ width: "95%" }}
                            >
                              <Select
                                styles={styles}
                                closeMenuOnSelect={true}
                                components={animatedComponents}
                                defaultValue={selectedOptionSortie}
                                onChange={onChangeSelectSortie}
                                options={allSorties}
                              />
                            </div>
                            <div className=" input-group-append">
                              <button
                                onClick={onChangeBtnSelectedSortie}
                                type="button"
                                class="btn btn-dark"
                              >
                                <i class="fas  fa-solid fa-arrow-down"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {btnSelectedSortie && products && products.length > 0 && (
                    <>
                      <div class="row">
                        <div className="col-sm-12 mt-3">
                          {filterTableProduct()}
                        </div>
                      </div>
                      {AddColisFormulaire()}
                    </>
                  )}
                </div>
                {btnSelectedSortie && btnSelectedWarehouse && (
                  <div className="card-footer">
                    <div className="col-sm-12  text-center">
                      <button className="btn btn-dark" onClick={onSendColis}>
                        Valider le choix
                      </button>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </section>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AddColisLivraison);
